import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../API/EndPoints";
import AxiosInstance from "../../API/AxiosInstance";

export const uploadDoc = createAsyncThunk(
  "doctor/uploaddoc",
  async ({ patientId, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const res = await AxiosInstance.post(
        `${API_ENDPOINTS.UPLOAD_PATIENT_DOC}?patientId=${patientId}`, // patientId in params
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchDocument = createAsyncThunk(
  "doctor/fetchDocument",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.get(
        API_ENDPOINTS.GET_UPLOAD_PATIENT,
        {
          params: payload,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const deleteDocument = createAsyncThunk(
  "doctor/deleteDocument",
  async (documentId, { rejectWithValue }) => {
    try {
      const response = await AxiosInstance.delete(
        `${API_ENDPOINTS.DELETE_DOCUMENT}?documentId=${documentId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const UploadDocSlice = createSlice({
  name: "doctor",
  initialState: {
    fetch: { data: [], loading: false, error: null },
    delete: { data: null, loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchDocument.pending, (state) => {
        state.fetch.loading = true;
        state.fetch.error = null;
      })
      .addCase(fetchDocument.fulfilled, (state, action) => {
        state.fetch.loading = false;
        state.fetch.data = action.payload || [];
      })
      .addCase(fetchDocument.rejected, (state, action) => {
        state.fetch.loading = false;
        state.fetch.error = action.payload;
      })
      .addCase(deleteDocument.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteDocument.fulfilled, (state, action) => {
        state.delete.loading = false;
        state.delete.data = action.payload;
      })
      .addCase(deleteDocument.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.error = action.payload;
      });
  },
});

export default UploadDocSlice.reducer;
